module.exports = __webpack_public_path__ + "img/premier.3dc4b88d.svg";